import { render, staticRenderFns } from "./pending-collection-query.vue?vue&type=template&id=9824dfd0"
import script from "./pending-collection-query.vue?vue&type=script&lang=ts"
export * from "./pending-collection-query.vue?vue&type=script&lang=ts"
import style0 from "./pending-collection-query.vue?vue&type=style&index=0&id=9824dfd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports